import basePath from "base_path";
import ActionTypes from "../constants/action_types";

import createReduxPromiseAction from "utils/create_redux_promise_action";

export default function fetchIssue(requestor) {
  return createReduxPromiseAction(
    ActionTypes.ISSUE_INFO_FETCH,
    (organisationId, issueId) =>
      requestor
        .get(
          `${basePath}/organisation/${organisationId}/issue/${issueId}/info`,
          {
            withCredentials: true,
          },
        )
        .then(response => response.data),
  );
}
